import React from 'react';

import moment from 'moment';

import { Wrapper, Label, SubLabel } from './style';

const statusMap = {
  ORDER: 'Pedido',
  WAITING: 'Receber',
  RECEIVED: 'Recebido',
  'NOT RECEIVED': 'Não recebido',
  RETURNED: 'Devolvido',
  CANCELED: 'Cancelado'
};

function ReceivingStatus({
  status,
  date,
  restaurants = [],
  consumeRestaurants = []
}) {
  if (!status) return null;

  const label = statusMap[status] || status;
  const formattedDate = date
    ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
    : '';

  const currentStatusCount = restaurants.length;
  const totalRestaurants = consumeRestaurants.length;

  return (
    <Wrapper type={label}>
      <Label isPedido={label === 'Pedido'}>
        {label}
        {totalRestaurants > 0 && (
          <>
            {' '}
            {currentStatusCount}/{totalRestaurants}
          </>
        )}
      </Label>
      <SubLabel>{formattedDate}</SubLabel>
    </Wrapper>
  );
}

export default ReceivingStatus;
